export const BoarTypes = {
    STATIONARY: "stationary",
    FARM: "farm",
    SPERM: "sperm"
};
